/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineLimitRule } from './machineLimitRule';


export interface CreateMachineLimitRulesResponseDTO { 
    geaPUID?: string;
    limitRules?: Array<MachineLimitRule>;
}

